import { render, staticRenderFns } from "./PasswordControl.vue?vue&type=template&id=5c960ea8"
import script from "./PasswordControl.vue?vue&type=script&lang=js"
export * from "./PasswordControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports